import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { CalculationTypeFormField } from '@/pages/instruments/new-instrument/form-fields/CalculationTypeFormField'
import { GuarantorNameField } from '@/pages/instruments/new-instrument/form-fields/GuarantorField'
import { GuarantorRatingsField } from '@/pages/instruments/new-instrument/form-fields/GuarantorRatingsField'
import { InvestmentWrapperField } from '@/pages/instruments/new-instrument/form-fields/InvestmentWrapperField'
import { IssuerNameSelectFormField } from '@/pages/instruments/new-instrument/form-fields/IssuerNameSelectField'
import { VenueFormField } from '@/pages/instruments/new-instrument/form-fields/VenueFormField'

export interface OptionalStructuredFieldsProps {}

export const OptionalStructuredFields: React.FC<OptionalStructuredFieldsProps> = ({}) => {
  return (
    <div className={'@container p-4 rounded-md bg-gray-100 justify-start space-y-6 h-min'}>
      <FormFieldRow>
        <InvestmentWrapperField />
        <IssuerNameSelectFormField />
        <GuarantorNameField />
        <GuarantorRatingsField />
      </FormFieldRow>
      <FormFieldRow>
        <CalculationTypeFormField />
        <VenueFormField />
      </FormFieldRow>
    </div>
  )
}
